import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilityComponent } from './pages/facility/facility.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '../core/core.module';

const routes: Routes = [
  {
    path: 'facility/:facilityId',
    component: FacilityComponent,
    children: [
      {
        path: 'questionnaire',
        loadChildren: () => import('src/app/questionnaire/questionnaire.module').then(m => m.QuestionnaireModule),
      },
      {
        path: 'recommendation',
        loadChildren: () => import('src/app/recommendation/recommendation.module').then(m => m.RecommendationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule, CoreModule],
  exports: [RouterModule],
})
export class FacilityRoutingModule {}
